<template>
  <div id="tryout-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li class="active">Dashboard Affiliate</li>
    </ol>
    <h1 class="page-header">Dashboard Affiliate</h1>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Dashboard</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3">
                    <label>Start Date*</label>
                    <div class="form-group">
                      <transition name="fade">
                        <div class="input-group">
                          <input
                            id="filterStart"
                            v-model="filter.start_date"
                            type="text"
                            class="form-control datepicker"
                            name="discussion_date"
                            readonly
                            style="color: black !important;background: white !important;"
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>End Date*</label>
                    <div class="form-group">
                      <transition name="fade">
                        <div class="col-md-2 col-xs-12">
                          <div class="input-group">
                            <input
                              id="filterEnd"
                              v-model="filter.end_date"
                              type="text"
                              class="form-control datepicker"
                              name="discussion_date"
                              style="color: black !important;background: white !important;"
                              readonly
                            />
                            <span class="input-group-btn">
                              <button class="btn btn-success" type="button">
                                <i class="fa fa-calendar"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>&nbsp;</label>
                    <div class="form-group">
                    <button class="btn btn-success btn-md" v-if="filter.start_date !== null || filter.end_date !== null" @click="submitFilter()">Apply</button>
                    <button class="btn btn-danger btn-md" v-if="filter.start_date !== null || filter.end_date !== null" @click="clearFilter()">Delete Filter</button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3" style="padding: 10px">
                    <div
                      style="
                        height: 100%;
                        text-align: center;
                        border-radius: 8px;
                        border: 1px solid green;
                      "
                    >
                      <h5>Affiliate Expense</h5>
                      <h4>Rp. {{ dataDash.total_expanse | currency }}</h4>
                    </div>
                  </div>
                  <div class="col-md-3" style="padding: 10px">
                    <div
                      style="
                        height: 100%;
                        text-align: center;
                        border-radius: 8px;
                        border: 1px solid green;
                      "
                    >
                      <h5>Total Akumulasi Koin</h5>
                      <h4>{{ dataDash.total_accumulate_coin | currency }}</h4>
                    </div>
                  </div>
                  <div class="col-md-3" style="padding: 10px">
                    <div
                      style="
                        height: 100%;
                        text-align: center;
                        border-radius: 8px;
                        border: 1px solid green;
                      "
                    >
                      <h5>Affiliate Income</h5>
                      <h4>Rp. {{ dataDash.total_income | currency }}</h4>
                    </div>
                  </div>
                  <div class="col-md-3" style="padding: 10px">
                    <div
                      style="
                        height: 100%;
                        text-align: center;
                        border-radius: 8px;
                        border: 1px solid green;
                      "
                    >
                      <h5>Affiliator Aktif</h5>
                      <h4>{{ dataDash.total_active_member }} User</h4>
                      <span>/ {{ dataDash.total_member }} Total </span>
                    </div>
                  </div>
                </div>
                <h4>List Affiliate :</h4>
                <div
                  class="col-md-4"
                  style="padding-bottom: 15px; padding-left: 0px"
                >
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1"
                      ><i class="fa fa-search"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      v-model="filter_affiliator.search"
                      aria-describedby="basic-addon1"
                      @keypress.enter="submitFilterAffiliator('search', filter_affiliator.search)"
                    />
                  </div>
                </div>

                <ul class="list-group">
                  <li
                    class="list-group-item"
                    style="display: flex; flex-flow: row;"
                  >
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">Username</div>
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">Nama</div>
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">
                      Sisa Koin
                      &nbsp;<i class="fa fa-sort" style="cursor:pointer;" @click="sort('total_coin')"></i>
                    </div>
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">
                      Total Koin 
                      &nbsp;<i class="fa fa-sort" style="cursor:pointer;" @click="sort('accumulation_coin')"></i>
                    </div>
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">
                      Click
                      &nbsp;<i class="fa fa-sort" style="cursor:pointer;" @click="sort('total_click')"></i></div>
                    <div class="col-md-2 col-xs-2" style="font-weight:bold;">
                      Telah diredem
                      &nbsp;<i class="fa fa-sort" style="cursor:pointer;" @click="sort('accumulation_redeem')"></i></div>
                  </li>
                  <li
                    class="list-group-item"
                    style="display: flex; flex-flow: row;"
                    v-for="item in listAffiliator.data"
                    :key="item"
                  >
                    <div class="col-md-2 col-xs-2">
                      {{ item.email }}
                    </div>
                    <div class="col-md-2 col-xs-2">{{ item.username }}</div>
                    <div class="col-md-2 col-xs-2">{{ item.total_coin | currency }}</div>
                    <div class="col-md-2 col-xs-2">{{ item.accumulation_coin | currency }}</div>
                    <div class="col-md-2 col-xs-2">{{ item.total_click | currency}}</div>
                    <div class="col-md-2 col-xs-2">{{ item.accumulation_redeem | currency }}</div>
                  </li>
                </ul>
                <div class="col-md-3" style="display:flex; flex-flow:row; padding-top: 20px;">
                  <!-- Single button -->
                  <div class="btn-group" style="margin-right: 15px;">
                    <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     {{ filter_affiliator.page_size }} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a @click="submitFilterAffiliator('page_size', 10)">10</a></li>
                      <li><a @click="submitFilterAffiliator('page_size', 15)">15</a></li>
                      <li><a @click="submitFilterAffiliator('page_size', 25)">25</a></li>
                    </ul>
                  </div>

                  <div class="input-group">
                    <span class="input-group-btn" v-if="filter_affiliator.page > 1">
                      <button class="btn btn-white" @click="submitFilterAffiliator('page',filter_affiliator.page - 1)" type="button" >Previous</button>
                    </span>
                    <input v-model="filter_affiliator.page" readonly type="text" class="form-control" style="text-align:center;">
                    <span class="input-group-btn">
                      <button class="btn btn-white" @click="submitFilterAffiliator('page', filter_affiliator.page + 1)" type="button">Next</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <p id="msg"></p>
  </div>
</template>
<script>
import Spinner from "@/components/plugins/Spinner";
import logo from "@/assets/img/launcher.png";
import AffService from "@/services/affiliate.js";
import moment from 'moment'
export default {
  name: "form-iklan",
  components: {
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      filterStart: null,
      filterEnd: null,
      isLoading: false,
      listAffiliator: [],
      dataDash: {
        total_expanse: 0,
        total_accumulate_coin: 0,
        total_coin: 0,
        total_income: 0,
        total_member: 0,
        total_active_member: 0,
      },
      filter: {
        start_date: null,
        end_date: null,
      },
      filter_affiliator: {
        page: 1,
        page_size: 10,
        search: null,
        sort_by: null,
        sort_mode: null
      },
      logo: logo,
    };
  },
  filters: {
    convertDate(v) {
      return moment.unix(v).format("DD MMMM YYYY");
    },
    currency(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    submitFilter(field, val) {
      // if(field !== 'page') this.filter.page = 1
      // this.filter[field] = val
      // this.getList() 
      this.getDataDashboard()
    },
    submitFilterAffiliator(field, val) {
      if(field !== 'page') this.filter_affiliator.page = 1
      this.filter_affiliator[field] = val
      this.getDataListAffiliator() 
    },
    sort(field){
      if (this.filter_affiliator.sort_mode === 'ASC') this.filter_affiliator.sort_mode = 'DESC'
      else  this.filter_affiliator.sort_mode = 'ASC'
      this.filter_affiliator.sort_by = field
      this.getDataListAffiliator()
    },
    clearFilter(){
      this.filter.start_date = null
      this.filter.end_date = null
      this.getDataDashboard()
    },
    getDataDashboard() {
      let context = this;
      context.isLoading = true;
      AffService.getDataDashboardAffiliate(context.filter, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.dataDash = result.data;
        }
      });
    },
    getDataListAffiliator() {
      let context = this;
      context.isLoading = true;
      AffService.getListAffiliator(context.filter_affiliator, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.listAffiliator = result.data;
        }
      });
    }
  },
  mounted: function () {
    let context = this;
    DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
    });
    DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
    });
    this.filter.start_date = '01/01/' + moment().year()
    this.filter.end_date =  moment(new Date()).format('DD/MM/YYYY');
    this.getDataDashboard();
    this.getDataListAffiliator()
  },
};
</script>



// WEBPACK FOOTER //
// AffiliateDashboard.vue?311d95b2